import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  SimpleForm,
  TextInput,
  BooleanInput,
  SelectInput,
  SelectArrayInput,
  FormDataConsumer,
  required
} from 'react-admin';

import { IirsaCountriesService } from '~config/services/iirsa_countries.service';
import { ROLE_CHOICES, ROLE_COUNTRY_MANAGER } from '~utils/permissions';

/**
 * Create/edit form for users.
 *
 * `password` is optional on edit: the API leaves it untouched when absent, so an
 * empty field means "keep the current password" rather than "blank it".
 *
 * Autocomplete is switched off on purpose. A username field followed by a password
 * field is exactly what the browser's password manager fills with the saved login
 * for this site -- the ADMIN's own credentials -- so saving an edit would silently
 * set the edited user's password to the admin's.
 */
class UserForm extends Component {
  state = { countries: [] };

  componentDidMount() {
    new IirsaCountriesService().get().then(response => {
      this.setState({ countries: response.data || [] });
    });
  }

  render() {
    const { isCreate, ...props } = this.props;
    return (
      // Back to the list after saving. It must come AFTER the spread: Create injects
      // `redirect="edit"` into these props, which would otherwise win.
      <SimpleForm {...props} redirect="list">
        <TextInput
          source="username"
          label="Usuario"
          validate={required()}
          options={{ autoComplete: 'off' }}
        />
        <TextInput
          source="password"
          label={isCreate ? 'Contraseña' : 'Nueva contraseña (opcional)'}
          type="password"
          validate={isCreate ? required() : undefined}
          // `new-password` is the value browsers honour: it marks the field as
          // setting a password, so no saved one is filled in.
          options={{ autoComplete: 'new-password' }}
        />
        <TextInput source="firstName" label="Nombre" />
        <TextInput source="lastName" label="Apellido" />
        <TextInput source="email" label="Email" type="email" />
        <SelectInput source="role" label="Rol" choices={ROLE_CHOICES} validate={required()} />
        {/* Countries only matter for the country-scoped role. */}
        <FormDataConsumer>
          {({ formData, ...rest }) =>
            formData && formData.role === ROLE_COUNTRY_MANAGER ? (
              <SelectArrayInput
                source="countries"
                label="Países"
                choices={this.state.countries}
                optionText="name"
                validate={required()}
                {...rest}
              />
            ) : null
          }
        </FormDataConsumer>
        <BooleanInput source="isActive" label="Activo" defaultValue={true} />
      </SimpleForm>
    );
  }
}

UserForm.propTypes = {
  isCreate: PropTypes.bool
};

export default UserForm;
